import { render, staticRenderFns } from "./ProuniEducationForm.vue?vue&type=template&id=b0d22448&scoped=true&"
import script from "./ProuniEducationForm.vue?vue&type=script&lang=ts&"
export * from "./ProuniEducationForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniEducationForm.vue?vue&type=style&index=0&id=b0d22448&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d22448",
  null
  
)

export default component.exports